export const state = {
  modalViewInvestment: false,
  investments: [],
  investment: {}
};

export default {};
